import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  COMPANY_LIST_REQUEST,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAILURE,
  COMPANY_LIST_RESET,
  COMPANY_GET_REQUEST,
  COMPANY_GET_SUCCESS,
  COMPANY_GET_FAILURE,
  COMPANY_GET_RESET,
  COMPANY_CREATE_REQUEST,
  COMPANY_CREATE_SUCCESS,
  COMPANY_CREATE_FAILURE,
  COMPANY_CREATE_RESET,
  COMPANY_EDIT_REQUEST,
  COMPANY_EDIT_SUCCESS,
  COMPANY_EDIT_FAILURE,
  COMPANY_EDIT_RESET,
  COMPANY_DEACTIVATE_REQUEST,
  COMPANY_DEACTIVATE_SUCCESS,
  COMPANY_DEACTIVATE_FAILURE,
  COMPANY_DEACTIVATE_RESET,
  COMPANY_EXPORT_REQUEST,
  COMPANY_EXPORT_SUCCESS,
  COMPANY_EXPORT_FAILURE,
  COMPANY_EXPORT_RESET,
} from './../../constants'

export function createCompany(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/companys`,
      method: 'POST',
      types: [
        COMPANY_CREATE_REQUEST,
        COMPANY_CREATE_SUCCESS,
        COMPANY_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getCompany(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/companys`,
      method: 'GET',
      types: [
        COMPANY_LIST_REQUEST,
        COMPANY_LIST_SUCCESS,
        COMPANY_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getCompanyByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/companys/${id}`,
      method: 'GET',
      types: [
        COMPANY_GET_REQUEST,
        COMPANY_GET_SUCCESS,
        COMPANY_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editCompany(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/companys/${id}`,
      method: 'PUT',
      types: [
        COMPANY_EDIT_REQUEST,
        COMPANY_EDIT_SUCCESS,
        COMPANY_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateCompany(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/companys/${id}/delete`,
      method: 'PUT',
      types: [
        COMPANY_DEACTIVATE_REQUEST,
        COMPANY_DEACTIVATE_SUCCESS,
        COMPANY_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportCompany(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/companys/exports`,
      method: 'GET',
      types: [
        COMPANY_EXPORT_REQUEST,
        COMPANY_EXPORT_SUCCESS,
        COMPANY_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetListCompany() {
  return {
    type: COMPANY_LIST_RESET,
  }
}
export function resetCreateCompany() {
  return {
    type: COMPANY_CREATE_RESET,
  }
}
export function resetEditCompany() {
  return {
    type: COMPANY_EDIT_RESET,
  }
}
export function resetGetCompany() {
  return {
    type: COMPANY_GET_RESET,
  }
}
export function resetDeactivateCompany() {
  return {
    type: COMPANY_DEACTIVATE_RESET,
  }
}
export function resetExportUser() {
  return {
    type: COMPANY_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/company/company-action.js